import { render } from "./wTable.vue?vue&type=template&id=21b99d39"
import script from "./wTable.vue?vue&type=script&lang=js"
export * from "./wTable.vue?vue&type=script&lang=js"

import "./wTable.vue?vue&type=style&index=0&id=21b99d39&lang=scss"

import exportComponent from "D:\\A-wy-work\\wy-vue-source\\wy-saas\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__